import React from "react";

import Backdrop from "./Backdrop";

import styled from "styled-components";

const LargeModal = styled.div`
  width: 50%;
  max-height: 80vh;
  position: fixed;
  z-index: 7000;
  box-sizing: border-box;
  padding: 10px;
  top: 10%;
  left: calc(24%);
  background: white;
  border-radius: 5px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const largeModal = (props) => (
  <div>
    <Backdrop clicked={props.closeModal} show={props.show} />
    <LargeModal
      style={{
        transform: props.show ? "translateY(0)" : "translateY(-100vh)",
        opacity: props.show ? "1" : "0",
      }}
    >
      {props.children}
    </LargeModal>
  </div>
);

export default largeModal;
